
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PermissionAlert } from './PermissionAlert';
import { MOCK_MODE } from '@/services/twilio/mock';
import { VoiceProviderToggle } from './VoiceProviderToggle';

interface TwilioDialerHeaderProps {
  onClose: () => void;
  micPermission: 'granted' | 'denied' | 'prompt';
  isInitializingDevices: boolean;
  onRequestPermissions: () => void;
}

export const TwilioDialerHeader = ({
  onClose,
  micPermission,
  isInitializingDevices,
  onRequestPermissions,
}: TwilioDialerHeaderProps) => {
  return (
    <div className="flex justify-between items-center p-3 border-b">
      <div className="flex items-center gap-2">
        <h3 className="font-medium text-base">Phone</h3>
        {MOCK_MODE && (
          <Badge variant="secondary" className="text-xs">Mock</Badge>
        )}
        <VoiceProviderToggle />
      </div>
      <div className="flex items-center gap-1">
        <PermissionAlert
          micPermission={micPermission}
          isInitializingDevices={isInitializingDevices}
          onRequestPermissions={onRequestPermissions}
          compact={true}
        />
        <Button 
          onClick={onClose} 
          variant="ghost" 
          size="icon" 
          className="h-6 w-6 text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close dialer</span>
        </Button>
      </div>
    </div>
  );
};
